import * as React from "react";
import { useEffect } from "react";
import { Catalogable } from "./CatalogViewer";
import { createRoot } from "react-dom/client";

interface CollapsideProps<T> {
  itemsRender: (category) => any;
  category: {
    items: T[];
    title: string;
    color: string;
  };
  itemsFilter: string;
}

export default function Collapside<T extends Catalogable>({
  itemsRender,
  category,
  itemsFilter,
}: CollapsideProps<T>) {
  useEffect(() => {
    Array.from(document.getElementsByClassName("category-section")).forEach((el) => {
      if (!el.classList.contains("active")) {
        (el.getElementsByClassName("accordion")[0] as HTMLButtonElement)?.click();
      }
      // prevent issues with accordion animation
      (el.getElementsByClassName("item-container")[0] as HTMLElement).style.maxHeight =
        "fit-content";
      (el.getElementsByClassName("item-container")[0] as HTMLElement).style.height = "auto";
    });
  }, [itemsFilter]);

  const onCollapsideButtonClick = (target: Element) => {
    if (!target.classList.contains("accordion")) {
      target = target.parentElement;
    }
    target.parentElement.classList.toggle("active");
    target.classList.add("animate");
    // accordion animation
    const followingSibling = target.nextElementSibling as HTMLElement;
    if (followingSibling.clientHeight) {
      if (!followingSibling.style.maxHeight || followingSibling.style.maxHeight === "fit-content") {
        followingSibling.style.maxHeight = `${followingSibling.clientHeight}px`;
      }
      followingSibling.style.height = followingSibling.style.maxHeight;
      setTimeout(() => {
        followingSibling.style.height = "0";
      }, 10);
    } else {
      followingSibling.style.height = followingSibling.style.maxHeight;
    }
  };

  return (
    <div key={category.title} className="category-section active">
      <>
        <button
          type="button"
          className="accordion clickable h-flex"
          style={{ borderLeftColor: category.color }}
          onClick={(it) => onCollapsideButtonClick(it.target as Element)}
        >
          <span>{category.title}</span>
          <div className="template-count">{category.items.length}</div>
        </button>
        <div className="item-container">{itemsRender(category)}</div>
      </>
    </div>
  );
}

Collapside.loadComponent = (elementId: string, props) => {
  const container = document.getElementById(elementId);
  const root = createRoot(container!);
  root.render(<Collapside {...props} />);
};
